import { Button, Card, OverlayTrigger, Popover, Spinner } from "react-bootstrap"
import { IOrderDetails, IPayment } from "../../interface/IOrderDetails"
import { useDeleteCertFromOrderMutation, useGetCertificateQuery, useGetOrderDetailsDataMutation } from "../../features/CallTPApi"
import { NumericFormat } from "react-number-format"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { IOrder } from "../../interface/IOrder"
import { ITenant } from "../../interface/ITenant"
import { setPrePaymantsInStore } from "../../features/prePaymantsSlice"
import { Gift, InfoCircle, Trash } from "react-bootstrap-icons"
import { useEffect, useState } from "react"
import { ICategoryAssignments } from "../../interface/ICategoryAssignments"
import { ISeat } from "../../interface/ISeat"
import { ISector } from "../../interface/ISector"
import { shallowEqual } from "react-redux"
import { ILocation } from "../../interface/ILocation"
import { Link } from "react-router-dom"

const DescriptionTooltip = () => {

    const popover = (
        <Popover id="popover-basic" className="shadow">
            <Popover.Header as="h3">
                Предуприждение
            </Popover.Header>
            <Popover.Body className="p-2">
                <p className="text-center">
                    <Link to="https://leningradcenter.ru/api/redirecturls/public-offer-certificates" target="_blank">ПУБЛИЧНАЯ ОФЕРТА (ОБ ОБРАЩЕНИИ/ИСПОЛЬЗОВАНИИ ПОДАРОЧНЫХ СЕРТИФИКАТОВ)</Link>
                </p>
                <p>
                    6.1.4. в случае приобретения билетов на сумму ниже номинала Подарочного сертификата, разница между ценой билетов и Номиналом Подарочного сертификата не сохраняется и не может быть использована при следующем приобретении билетов Продавца;
                </p>

            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger trigger={['click', 'hover']} placement="bottom" overlay={popover}>
            <InfoCircle />
            {/* <Button variant="success">Click me to see</Button> */}
        </OverlayTrigger>
    )
}

export const CertPament = ({ payment }: { payment: IPayment }) => {

    const { data, isLoading } = useGetCertificateQuery(payment.certificateId as string)
    const basket = useSelector((state: any) => state.basket) as ISeat[]
    const sessionAssignments = useSelector((state: any) => state.sessionAssignments, shallowEqual) as ICategoryAssignments[];
    const location = useSelector((state: any) => state.locationScheme, shallowEqual) as ILocation;
    const [getOrderDetails, { isLoading: isLoadingOrderDetails }] = useGetOrderDetailsDataMutation()
    // const [deletePayment, { isLoading: isLoadingDeletePayment }] = useDeletePaymentMutation()
    const order = useSelector((state: any) => state.order) as IOrder;
    const tenant = useSelector((state: any) => state.tenant) as ITenant;
    const dispatch = useDispatch()
    const [summ, setSumm] = useState<number>(0)
    const [deleteCertFromOrder, { isLoading: isLoadingDeletePayment }] = useDeleteCertFromOrderMutation()


    useEffect(() => {
        if (!location) {
            return;
        }
        if (!basket) {
            return;
        }
        const newbasketItems = basket.map(item => {
            const itemAssignment = sessionAssignments.find((cat: ICategoryAssignments) => cat.targetId === item.id) as ICategoryAssignments;
            const sector = location.sectors.find((sector: ISector) => sector.seats.some((seat: ISeat) => seat.id === item.id));
            const seat = sector ? sector.seats.find((seat: ISeat) => seat.id === item.id) : undefined;
            return {
                id: item.id,
                price: itemAssignment.price,
                color: itemAssignment.color ?? "black",
                categoryName: itemAssignment.name,
                row: seat ? seat.row : undefined,
                seat: seat ? seat.place : undefined,
                quantity: 1,
                priceCategoryAssignmentId: itemAssignment.id,
                priceCategoryTarget: 3
            };
        });
        setSumm(newbasketItems.reduce((sum, item) => sum + item.price * item.quantity, 0))
    }, [basket])

    const getCertInOrder = () => {
        getOrderDetails({ id: order.id, tenantId: tenant.id }).then((r: any) => {
            if (r) {
                const orderData = { ...r.data } as IOrderDetails
                console.log(orderData)
                dispatch(setPrePaymantsInStore(orderData.payments as any))
            }
        })
    }
    const delCert = () => {
        deleteCertFromOrder({ certificateId: payment.certificateId, id: order.id }).then((r: any) => {
            if (!r.error) {
                getCertInOrder()
            }
        })
    }

    return (
        <Card className="shadow con-hide-action-btn tpBg">
            <Card.Body className="position-relative p-1">
                {(!isLoading && !isLoadingOrderDetails && !isLoadingDeletePayment) ?
                    <div className="d-grid gap-1">
                        <div className="d-grid align-items-center justify-content-center">
                            <div className="text-center d-flex align-items-center gap-2 fs-5 fw-bold">
                                <Gift />
                                {data?.certificateNumber}
                            </div>
                        </div>
                        <div className="d-grid align-items-center justify-content-center">
                            <div className="text-center text-muted">
                                Добавлен на сумму
                            </div>
                            <div className="fw-bold text-center">
                                <NumericFormat displayType={'text'} value={payment?.amount} thousandSeparator=" " /> ₽
                            </div>
                        </div>
                        {(data && summ < data?.amount) &&
                            <div className="fw-bold text-center text-danger-emphasis" style={{ fontSize: "12px" }}>
                                <div>Нераспределенный остаток <DescriptionTooltip /></div>
                                {data?.amount - summ} ₽
                            </div>
                        }
                    </div>
                    :
                    <div className="d-grid align-items-center justify-content-center">
                        <Spinner />
                    </div>
                }
                <div className="position-absolute" style={{ right: '10px', top: '10px' }}>
                    <Button variant="outline-danger" size="sm" className="btn-action" onClick={() => { delCert() }}><Trash /></Button>
                </div>
            </Card.Body>
        </Card>
    )
}